<template>
    <div class="datetime-component">
        <b-datetimepicker
                rounded
                icon="calendar-today"
                horizontal-time-picker
                :placeholder="placeholder"
                :required="required"
                v-bind:value="valueAsDate"
                v-on:input="valueChanged($event)">
            </b-datetimepicker>
    </div>
</template>

<script>
var moment = require('moment');

export default {
    name: 'DateTime',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    methods: {
        valueChanged (event) {
            let date = moment(event)
            this.value = date.toISOString(true)
            this.$emit('input', date.toISOString(true))
        },
    },
    mounted(){

    },     
    computed: {
        placeholder () {
            return this.component.placeholder ?? null
        },
        valueAsDate () {
            return moment(this.value).toDate()
        },
    }
}

</script>

<style>

</style>

